import { Languages } from '@/components/LanguageSelector/types.ts'

export default function isLanguageSupported(language: string) {
  for (const lang of Object.values(Languages)) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
    if (lang === language) return true
  }

  return false
}
